export class KeyValueEntity {
	public id?: number;
    public key!: string;
    public value!: any;
}
